import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-646e7b54"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  key: 0,
  class: "card-body"
}
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "d-inline-block position-relative ms-2" }
const _hoisted_8 = { class: "d-inline-block mb-2 my-2 fs-2 fw-bold" }
const _hoisted_9 = {
  class: "d-flex mx-4",
  style: {"margin-top":"8px"}
}
const _hoisted_10 = { class: "d-inline-block mx-4" }
const _hoisted_11 = { class: "d-inline-block mx-4" }
const _hoisted_12 = { class: "d-flex flex-wrap m-5" }
const _hoisted_13 = { class: "lesson-container mx-2 my-2" }
const _hoisted_14 = { class: "badge-number bg-dark" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold p-3 lesson-text" }, "Packages Lessons", -1))
const _hoisted_16 = { class: "fw-semibold p-3 lesson-text" }
const _hoisted_17 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.can('create', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('Package Details')), 1)
          ])
        ]),
        (_ctx.packages.packages.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages.packages, (p, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "my-4"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(p.packageType), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["d-inline-block position-absolute h-6px bottom-0 end-0 start-0 translate rounded", _ctx.bgClasses[index]])
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("strong", _hoisted_10, "Package Start Date " + _toDisplayString(p.startOfPackageDate), 1),
                      _createElementVNode("strong", _hoisted_11, "Package End Date " + _toDisplayString(p.endOfPackageDate), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(p.totalLessonCount), 1),
                      _hoisted_15
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.lessonCountByAttendance, (item, index) => {
                      return _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "lesson-container mx-2 my-2"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["badge-number", _ctx.showPackageColor(item.attendanceName)])
                        }, _toDisplayString(item.lessonCount), 3),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.showPackageTitle(item.attendanceName)), 1)
                      ])), [
                        [_vShow, 
              item.attendanceName !== 'unreachable' &&
              item.attendanceName !== 'pending'
            ]
                      ])
                    }), 128))
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("h3", _hoisted_17, " There is no running packages for this customer "))
      ]))
    : _createCommentVNode("", true)
}